export const popupStyles = `
  overflow: scroll;
  max-height: 80% !important;
  width: 30%;
  position: fixed;
  margin-left: 35%;
  margin-top: 10.5%;
  top: 0;
  left: 0;
  background-color: white;
  padding-bottom: 20px`;
